var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Sub Grupos","p-read-link":"subGroup.read.one","p-create-link":"subGroup.create","p-name":"subGroup"}})}
var staticRenderFns = []

export { render, staticRenderFns }